module.exports = __webpack_public_path__ + "img/cyber.2d3f44a1.svg";